// stores/tableStore.js

import { defineStore } from "pinia";
import api from "@/services/api";
//import { filter } from "core-js/core/array";

export const useTableStore = defineStore("tableStore", {
  state: () => ({
    data: [],
    loading: false,
    error: null,
    total: 0,
    actualPage: 1,
    perPage: 10,
    totalPages: 1,
    filterSearch: "",
    filterApodoLector: "",
    filterTimestamp: "",
    filterEstado: "",
  }),
  getters: {
    // Siempre devolver 1 para la página de la tabla
    tablePage: () => 1,
  },
  actions: {
    /**
     * Fetches table data with pagination and optional filters.
     * @param {number} page - Página actual.
     * @param {number} perPage - Registros por página.
     * @param {string} search - Término de búsqueda para ApodoDispositivo.
     * @param {string} apodoLector - Término de búsqueda para ApodoLector.
     * @param {string} timestamp - Término de búsqueda para Timestamp.
     */
    async fetchTableData(
      page = this.actualPage,
      perPage = this.perPage,
      search = this.filterSearch,
      apodoLector = this.filterApodoLector,
      timestamp = this.filterTimestamp,
      estado = this.filterEstado
    ) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.getTableData(
          page,
          perPage,
          search,
          apodoLector,
          timestamp,
          estado
        );

        // Procesar los datos para expandir "Valor"
        const processedData = response.data.map((row) => {
          if (row.Valor) {
            try {
              const valorObj = JSON.parse(row.Valor);
              delete row.Valor;
              delete row.Variable;
              return { ...row, ...valorObj };
            } catch (error) {
              console.warn(
                `Error al parsear "Valor" para Dispositivo: ${row.Dispositivo}`,
                error
              );
              return row;
            }
          }
          return row;
        });

        this.data = processedData;
        this.total = response.total;
        // No modificar actualPage ni perPage, para mantener la selección del usuario:
        // this.actualPage = response.page;
        // this.perPage = response.per_page;
        this.totalPages = response.total_pages;
        console.log(
          "Datos de la tabla actualizados",
          this.data,
          "Pagina:",
          this.actualPage
        );
      } catch (err) {
        this.error = err.message || "Error al obtener los datos";
      } finally {
        this.loading = false;
      }
    },
    /**
     * Actualiza el filtro de búsqueda para ApodoDispositivo.
     */
    setFilterSearch(newSearch) {
      this.filterSearch = newSearch;
      this.actualPage = 1;
      this.fetchTableData(1, this.perPage);
    },
    /**
     * Actualiza el filtro para ApodoLector.
     */
    setFilterApodoLector(newFilter) {
      this.filterApodoLector = newFilter;
      this.actualPage = 1;
      this.fetchTableData(1, this.perPage);
    },
    /**
     * Actualiza el filtro para Timestamp.
     */
    setFilterTimestamp(newFilter) {
      this.filterTimestamp = newFilter;
      this.actualPage = 1;
      this.fetchTableData(1, this.perPage);
    },
    /**
     * Actualiza el filtro para Estado.
     */
    setFilterEstado(newFilter) {
      this.filterEstado = newFilter;
      this.actualPage = 1;
      this.fetchTableData(1, this.perPage);
    },
    setActualPage(pagina) {
      this.actualPage = pagina;
      // Se incluyen los filtros actuales en la llamada:
      this.fetchTableData(pagina, this.perPage);
    },
    setRegistrosPorPagina(limit) {
      this.perPage = limit;
      this.actualPage = 1;
      this.fetchTableData(1, limit);
    },
  },
});
